import { createContext, useContext } from 'react';

import { buildDevAiWorkspaceAri } from './utils';

export type TenantDataContextType = {
	tenantContexts: ReadonlyArray<{
		readonly cloudId: string;
		readonly orgId: string;
		readonly devaiEntitlementId: string | null;
		readonly devAiActivationId: string | null;
		readonly jiraActivationId: string | null;
	}>;
};

export const TenantDataContext = createContext<TenantDataContextType | null>(null);

export const useTenantData = () => {
	const context = useContext(TenantDataContext);
	if (!context) {
		throw new Error('useTenantData must be used within a TenantDataProvider');
	}
	return context;
};

export const useWorkspaceAri = (): string | null => {
	const { tenantContexts } = useTenantData();
	const firstActivationId = tenantContexts[0]?.devAiActivationId;
	return firstActivationId ? buildDevAiWorkspaceAri(firstActivationId) : null;
};
